import { render, staticRenderFns } from "./templateContentButtonQuickReply.vue?vue&type=template&id=07949f79&"
import script from "./templateContentButtonQuickReply.vue?vue&type=script&lang=ts&"
export * from "./templateContentButtonQuickReply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports